import { ContextStorage } from "@/libs/contextStorage";
import { get } from "lodash";
import isEmpty from "lodash/isEmpty";

class DynamicYieldService {
  createDYContextObject(type: string, language: string, data?: string[]) {
    return {
      type: this.getDYPageType(type),
      ...(!isEmpty(data) && { data }),
      lng: this.getISOLanguage(language)
    };
  }

  setDYContext(type: string, language: string, data?: string[]) {
    const DY = window.DY || {};
    window.DY = DY;
    DY.recommendationContext = this.createDYContextObject(type, language, data);
  }

  setDYHead(type: string, language: string, data?: string[]) {
    const existing = document.querySelector("#dy-context");
    if (existing) existing.remove();
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.id = "dy-context";
    script.textContent = `
      window.DY = window.DY || {};
      DY.recommendationContext = ${JSON.stringify(
        this.createDYContextObject(type, language, data)
      )};
    `;
    const firstScriptInHead = document.head.querySelector("script");
    if (firstScriptInHead) {
      document.head.insertBefore(script, firstScriptInHead);
    } else {
      document.head.appendChild(script);
    }

    if (window.DY) {
      setTimeout(() => {
        this.setDYContext(type, language, data);
      }, 500);
    }

    return script;
  }

  getISOLanguage(language: string) {
    const store = ContextStorage.store.getState();
    const settings = store.common.settings;
    const countrySlug = get(settings, "countrySHORT", "ae").toUpperCase();
    const languageSlug = store.common.language;
    const languageCountry = languageSlug + "_" + countrySlug;
    return languageCountry;
  }

  getDYPageType(pageType: string) {
    switch (pageType?.toLocaleLowerCase?.()) {
      case "home":
        return "HOMEPAGE";
      case "plp":
      case "brand":
        return "CATEGORY";
      case "pdp":
        return "PRODUCT";
      case "cart":
        return "CART";
      case "common":
      default:
        return "OTHER";
    }
  }
}

export default new DynamicYieldService();
